import { useQuery } from '@apollo/client'

import { GET_CITY_SUGGESTIONS } from 'features/Cities/queries-legacy'
import { GTCitySuggestion, GTCitySuggestionsResponse } from 'gql/types.generated'

interface IUseCityOptions {
  skip?: boolean
}

export const useCity = (cityId: string, { skip }: IUseCityOptions): GTCitySuggestion | null => {
  const { data } = useQuery<{ citySuggestions: GTCitySuggestionsResponse }>(GET_CITY_SUGGESTIONS, {
    skip,
    variables: {
      input: {
        id: cityId
      }
    }
  })

  return data?.citySuggestions?.items.at(0) || null
}
